type BootstrapFn = () => void;

const registry = new Set<BootstrapFn>();
let initialized = false;
let scheduled = false;

const runAll = () => {
  registry.forEach((bootstrap) => {
    try {
      bootstrap();
    } catch (error) {
      // Keep other modules bootstrapping even if one module fails.
      // eslint-disable-next-line no-console
      console.error('[IPS-React] bootstrap failed', error);
    }
  });
};

const scheduleRun = () => {
  if (scheduled) {
    return;
  }

  scheduled = true;
  window.requestAnimationFrame(() => {
    scheduled = false;
    runAll();
  });
};

const init = () => {
  if (initialized) {
    return;
  }

  initialized = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll, { once: true });
  } else {
    runAll();
  }

  const root = document.body || document.documentElement;
  if (root) {
    const observer = new MutationObserver(() => {
      scheduleRun();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('ips:myaccount-content-updated', scheduleRun);

  const maybeJquery = (window as unknown as { jQuery?: any }).jQuery;
  if (maybeJquery) {
    maybeJquery(document).on(
      'ips_wcmap_myaccount_content_loaded ips-wcmap-myaccount-section-loaded ips_wcmap_myaccount_section_loaded wc_fragments_refreshed updated_wc_div',
      scheduleRun
    );
  }
};

export const registerDynamicBootstrap = (bootstrap: BootstrapFn) => {
  registry.add(bootstrap);
  init();
  scheduleRun();
};
